import React, { useState, useEffect, useRef } from 'react';
import './MessageForm.css';
import imageCompression from 'browser-image-compression';

export function MessageForm({ lat, lng, onClose, onSuccess }) {
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [message, setMessage] = useState('');
    const [image, setImage] = useState('');
    const nameref = useRef(null);

    useEffect(() => {
        const timer = setTimeout(() => {
            nameref.current?.focus();
        }, 100);
        return () => clearTimeout(timer);
    }, []);

    const stopMapInterference = (e) => {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
    };

    const handleImageChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        try {
            const options = {
                maxSizeMB: 0.15, // 150KB
                maxWidthOrHeight: 1024,
                useWebWorker: true
            };

            const compressedFile = await imageCompression(file, options);
            const base64 = await imageCompression.getDataUrlFromFile(compressedFile);
            setImage(base64);
        } catch (error) {
            console.error('Errore nella compressione immagine:', error);
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const formData = {
            email,
            name,
            message,
            image,
            latitude: lat,
            longitude: lng
        };

        try {
            const response = await fetch('https://qdrfojrgdd.execute-api.eu-south-1.amazonaws.com/prod/marker', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });

            if (!response.ok) throw new Error('Network response was not ok');
            const data = await response.json();
            console.log(data);
            onClose();
            onSuccess();
        } catch (error) {
            console.error(error);
            onClose();
            onSuccess();
        }
    };

    return (
        <div
            className="info-window-content"
            style={{ pointerEvents: 'auto', zIndex: 9999 }}
            onClick={stopMapInterference}
            onMouseDown={stopMapInterference}
            tabIndex={0}
        >
            <form onSubmit={handleSubmit} className="message-form">
                <div>
                    <label>Come ti chiami?</label>
                    <input
                        type="text"
                        ref={nameref}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        onClick={stopMapInterference}
                        onMouseDown={stopMapInterference}
                        required
                    />
                </div>



                <div>
                    <label>Che spazio è? Perché qui?</label>
                    <textarea
                        value={message}
                        onChange={(e) => {
                            if (e.target.value.length <= 600) setMessage(e.target.value);
                        }}
                        maxLength={600}
                        rows={5}
                        onClick={stopMapInterference}
                        onMouseDown={stopMapInterference}
                        required
                    />
                </div>

                <div>
                    <label className="upload-label">
                        Se vuoi allega un’immagine
                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                            onClick={stopMapInterference}
                            onMouseDown={stopMapInterference}
                        />
                    </label>
                    {image && <div className="success-message">Immagine aggiunta!</div>}
                </div>

                <div>
                    <label>La tua email</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        onClick={stopMapInterference}
                        onMouseDown={stopMapInterference}
                        required
                    />
                </div>

                <div>
                    <button
                        type="submit"
                        onClick={stopMapInterference}
                        onMouseDown={stopMapInterference}
                    >
                        Invia
                    </button>
                </div>
            </form>
        </div>
    );
}